import { RotateCcw } from "lucide-react";
import { useRouter } from "@/lib/nav";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { settleRedirect } from "@/lib/redirect-error";
import { recreateChangeOrder } from "@/api/actions/change-order";
import { changeOrderPath } from "@buildpy/core/modules/change-order/view";

interface Props {
  contractId: string;
  changeOrderId: string;
}

// 승인할 수 없게 된 보낸 건 — 같은 항목의 새 초안을 만들고 원본을 파기한 뒤 새 초안으로 옮긴다.
const ChangeOrderRecreateButton = ({ contractId, changeOrderId }: Props) => {
  const router = useRouter();
  const [pending, setPending] = useState(false);

  const recreate = async () => {
    setPending(true);
    try {
      const result = await recreateChangeOrder(changeOrderId);
      if (!result.ok) {
        toast.error(result.message);
        return;
      }
      toast.success("회수하고 새 초안을 만들었습니다 — 확인한 뒤 다시 보내 주세요");
      router.push(changeOrderPath(contractId, result.change_order_id));
    } catch (error) {
      if (settleRedirect(error)) return;
      toast.error("회수하고 새로 만들지 못했습니다");
    } finally {
      setPending(false);
    }
  };

  return (
    <Button data-testid="change-order-recreate" disabled={pending} size="sm" variant="primary" onClick={() => void recreate()}>
      <RotateCcw />
      회수하고 새로 만들기
    </Button>
  );
};

export default ChangeOrderRecreateButton;
